import { AuthContext } from 'AuthContext'
import useEledoAccountMembers from 'graphql/hooks/useAccountMembers'
import React, { useContext } from 'react'
import classnames from 'classnames';
import { ADD_ACCOUNT_MEMBER_ROLE, EledoAccountMember, EledoAccountMemberRoleData, EledoAccountMemberRoleVars, EledoRemoveAccountMemberData, EledoRemoveAccountMemberVars, GET_ACCOUNT_MEMBERS, REMOVE_ACCOUNT_MEMBER, REMOVE_ACCOUNT_MEMBER_ROLE } from 'graphql/EledoAccountMemberQueries';
import EledoConfirmButton from './EledoConfirmButton';
import { useMutation } from '@apollo/client';
import NotyfContext from 'context/NotyfContext';
import { showNotyf } from 'hooks';

const EledoAccountMembersList = () => {
  const auth = useContext(AuthContext)
  const { membersLoading, error, members } = useEledoAccountMembers({limit: 10, page: 1})

  return (
    <>
    <div className={classnames("w-layout-grid", "header-grid")} style={{marginTop: 0}}>
      <div className="_wf-table-cell">
        <div>Name</div>
      </div>
      <div className="_wf-table-cell">
        <div>Role</div>
      </div>
      <div className="_wf-table-cell">
        <div>Actions</div>
      </div>
    </div>
    { members?.map((member, index) => (
      <div className={classnames("w-layout-grid", "data-grid")} key={member.user.id}>
        <div className="_wf-table-cell">
          { member.user.email }
        </div>
        <div className="_wf-table-cell">
          <div>
            <EledoMemberRoles member={member} />
          </div>
        </div>
        <div className="_wf-table-cell">
          <div>
            <EledoMemberActions member={member} currentUserId={auth.user?.id} isAdmin={auth.roles?.includes("AccountAdmin") || false}/>
          </div>
        </div>
      </div>))
    }
    </>
  )
}

export const EledoMemberRoles = ({member, editable = true}: { member: EledoAccountMember, editable?: boolean }) => {
  const isMember = member.roles.includes("AccountMember")
  const isAdmin = member.roles.includes("AccountAdmin")
  
  return (
    <div>
      { isAdmin &&
        <>
          <i className={classnames("icon-user-tie")}/> Administrator
        </>
      }
    </div>
  )
}

const EledoMemberActions = ({member, currentUserId, isAdmin}: { member: EledoAccountMember, currentUserId?: string, isAdmin: boolean }) => {
  const [promoteMember] = useMutation<EledoAccountMemberRoleData, EledoAccountMemberRoleVars>(ADD_ACCOUNT_MEMBER_ROLE,
    { refetchQueries: [{ query: GET_ACCOUNT_MEMBERS, variables:{limit: 10, page: 1}}],
      onError(error) { showNotyf(error.message, notyf, "error") },
      onCompleted() { showNotyf("User promoted!", notyf, "success") }
    } )
  
  const [degradeMember] = useMutation<EledoAccountMemberRoleData, EledoAccountMemberRoleVars>(REMOVE_ACCOUNT_MEMBER_ROLE,
     {refetchQueries: [{ query: GET_ACCOUNT_MEMBERS, variables:{limit: 10, page: 1}}],
      onError(error) { showNotyf(error.message, notyf, "error") },
      onCompleted() { showNotyf("User degraded!", notyf, "success") } } )

  const [removeMember] = useMutation<EledoRemoveAccountMemberData, EledoRemoveAccountMemberVars>(REMOVE_ACCOUNT_MEMBER,
    { refetchQueries: [{ query: GET_ACCOUNT_MEMBERS, variables:{limit: 10, page: 1}}],
      onError(error) { showNotyf(error.message, notyf, "error") },
      onCompleted() { showNotyf("User removed!", notyf, "success") } } )

  const notyf = useContext(NotyfContext);

  const memberIsAdmin = member.roles.includes("AccountAdmin")
  const canPromote = currentUserId !== member.user.id && !memberIsAdmin && isAdmin
  const canDegrade = currentUserId !== member.user.id && memberIsAdmin && isAdmin
  const canRemove = currentUserId !== member.user.id && isAdmin

  return (
    <div>
      { canPromote && 
        <EledoConfirmButton modalTitle="Promote?" modalText={"Are you sure you want to promote " + member.user.email + " to Administrator?"}
          modalConfirmText="Promote" modalCancelText="Cancel" onSuccess={() => {
            member.user.id && promoteMember({ variables: { userId: member.user.id, role: "AccountAdmin"}})}} onFailure={() => {}}>
          <i className="icon-user-tie" /> Promote
        </EledoConfirmButton>
      }
      { canDegrade && 
        <EledoConfirmButton modalTitle="Degrade?" modalText={"Are you sure you want to degrade " + member.user.email + " to Account Member?"}
          modalConfirmText="Degrade" modalCancelText="Cancel" onSuccess={() => {
            member.user.id && degradeMember({ variables: { userId: member.user.id, role: "AccountAdmin"}})}} onFailure={() => {}}>
          <i className="icon-user1" /> Degrade
        </EledoConfirmButton>
      }
      { canRemove &&
        <EledoConfirmButton modalTitle="Remove?" modalText={"Are you sure you want to remove " + member.user.email + " from this account?"}
          modalConfirmText="Remove" modalCancelText="Cancel" onSuccess={() => { member.user.id && removeMember({ variables: { userId: member.user.id}})}} onFailure={() => {}}>
          <i className="icon-user-minus" /> Remove
        </EledoConfirmButton>
      }
    </div>
  )
}

export default EledoAccountMembersList